import { cn } from "@/lib/utils";

interface PromoWithTitleProps {
  title?: string | React.ReactNode;
  image?: string;
  titleClassName?: string;
  containerClassName?: string;
  imageClassName?: string;
  position?: "top" | "bottom" | "center";
  reactNode?: React.ReactNode;
}

export const PromoWithTitle = ({
  title,
  image,
  titleClassName,
  containerClassName,
  imageClassName,
  position = "top",
  reactNode,
}: PromoWithTitleProps) => (
  <div
    className={cn(
      "relative flex h-full w-full flex-col items-center justify-center",
      containerClassName,
    )}
  >
    {position === "top" && title && (
      <span
        className={cn(
          "mb-7 mt-[111px] w-full max-w-[80%] whitespace-break-spaces text-center text-[clamp(36px,2.06vw,52px)] font-bold leading-[48px] text-white",
          titleClassName,
        )}
      >
        {title}
      </span>
    )}
    {position === "center" && (
      <span
        className={cn(
          "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
          "w-full max-w-[50%] whitespace-break-spaces text-center text-[clamp(36px,2.06vw,52px)] font-bold leading-[48px] text-white",
          titleClassName,
        )}
      >
        {title}
      </span>
    )}
    {!!image && (
      <img
        src={image}
        alt="PromptLayer"
        loading="lazy"
        className={cn("h-full max-h-[75%] w-full object-contain pl-12", imageClassName)}
      />
    )}

    {!!reactNode && reactNode}

    {position === "bottom" && title && (
      <span
        className={cn(
          "mt-7 w-full max-w-[80%] whitespace-break-spaces text-center text-[clamp(36px,2.06vw,52px)] font-bold leading-[48px] text-white",
          titleClassName,
        )}
      >
        {title}
      </span>
    )}
  </div>
);
